import moment from 'moment';

export default [
  moment.duration(3, 'months'),
  moment.duration(6, 'months'),
  moment.duration(1, 'years')
];